import { ActionTypes } from "./actionTypes";
import { client } from "../axios";
import { fileNameMaker } from "../utils";
import { push } from "connected-react-router";
import { compressAccurately } from "image-conversion";
import reflect from "../translate/translations";
import { getRoistatCookie } from "../utils/cookies";

export const changeNumberField = (name, value) => {
  return {
    type: ActionTypes.CHANGE_NUMBER_FIELD,
    payload: { name, value },
  };
};
export const setTitle = (title) => {
  return { type: ActionTypes.SET_TITLE, payload: title };
};
export const setSubTitle = (subTitle) => {
  return { type: ActionTypes.SET_SUB_TITLE, payload: subTitle };
};
export const resetDATA = () => {
  return { type: ActionTypes.RESTART_DATA, payload: "" };
};
export const resetError = () => {
  return { type: ActionTypes.RESET_ERROR, payload: "" };
};
export const selectUser = (user) => {
  return { type: ActionTypes.SELECT_USER, payload: user };
};
export const changeNumber = () => {
  return { type: ActionTypes.CHANGE_NUMBER, payload: false };
};
export const changePassportType = (passportType) => {
  return { type: ActionTypes.CHANGE_PASSPORT_TYPE, payload: { passportType } };
};
export const getOTPRequest = () => {
  return { type: ActionTypes.GET_OTP_REQUEST };
};
export const getOTPsuccess = (data, phone) => {
  return { type: ActionTypes.GET_OTP_SUCCESS, payload: { data, phone } };
};
export const getOTPerror = (error) => {
  return { type: ActionTypes.GET_OTP_ERROR, payload: error };
};
export const stopLoading = () => {
  return { type: ActionTypes.STOP_LOADING };
};
export const getOTP = (phone) => async (dispatch) => {
  try {
    dispatch(getOTPRequest());
    const response = await client.post("/check_phone", { phone });
    if (response.data.info.includes("Select client")) {
      dispatch(checkOTPSuccess(response.data.payload));
      dispatch(getOTPsuccess(response.data.payload, phone));
      dispatch(throwErrorMessage("selectUser"));
    } else {
      dispatch(getOTPsuccess(response.data.payload, phone));
    }
    dispatch(stopLoading());
  } catch (error) {
    if (error.response.data.errors.includes("incorrect phone number")) {
      dispatch(getOTPerror(error));
      dispatch(throwErrorMessage("uncorrectPhone"));
    } else {
      dispatch(getOTPerror(error));
      dispatch(throwErrorMessage("unexpected"));
    }
  }
};
export const checkOTPRequest = () => {
  return { type: ActionTypes.CHECK_OTP_CODE_REQUEST, payload: "" };
};
export const checkOTPSuccess = (data) => {
  return { type: ActionTypes.CHECK_OTP_CODE_SUCCESS, payload: data };
};

export const checkOTPError = (error) => {
  return { type: ActionTypes.CHEKC_OTP_CODE_ERROR, payload: error };
};

export const checkOTP =
  (code = 0) =>
  async (dispatch, getState) => {
    try {
      const state = getState().sendOtpState;

      dispatch(checkOTPRequest());
      const data = {
        otp_id: state.otp_id,
        otp_code: code,
      };
      const response = await client.post("/check_otp", data);
      // eslint-disable-next-line no-undef
      roistat.event.send("doc_website_otp_correct");
      dispatch(checkOTPSuccess(response.data.payload));
      dispatch(throwErrorMessage("selectUser"));
    } catch (error) {
      dispatch(checkOTPError(error));
      if (error.response.status === 400) {
        dispatch(throwErrorMessage("incorrectCode"));
      } else if (error.response.status === 401) {
        dispatch(throwErrorMessage("expiredCode"));
      } else {
        dispatch(throwErrorMessage("unexpected"));
      }
    }
  };
export const sendFilesRequest = () => {
  return { type: ActionTypes.SEND_FILES_REQUEST, payload: {} };
};
export const sendFilesSuccess = (data) => {
  return { type: ActionTypes.SEND_FILES_SUCCESS, payload: data };
};
export const sendFilesError = (error) => {
  return {
    type: ActionTypes.SEND_FILES_ERROR,
    payload: error,
  };
};
export const sendFiles =
  (files = null, app_id = null, client_id = null, history) =>
  async (dispatch) => {
    try {
      dispatch(sendFilesRequest());
      const data = new FormData();
      data.append("client_id", client_id);
      data.append("app_id", app_id);
      data.append("roistat_visit", getRoistatCookie());
      for (const item of files) {
        const name = fileNameMaker(item.file.type, item.type, item.file.size);

        if (item.file.size > 1000000) {
          const c = await compressAccurately(item.file, 500);
          data.append("files", c, name);
        } else {
          data.append("files", item.file, name);
        }
      }

      const response = await client.post("/send", data);
      dispatch(sendFilesSuccess(response));

      history.push("/success");
    } catch (error) {
      if (error?.response?.data?.errors?.includes("err.appID_invalid")) {
        dispatch(sendFilesError(error));
        dispatch(throwErrorMessage("incorrectAppId"));
      } else {
        dispatch(sendFilesError(error));
        dispatch(throwErrorMessage("unexpected"));
      }
    }
  };

const createApplicationRequest = () => {
  return { type: ActionTypes.CREATE_APPLICATION_REQUEST, payload: "" };
};
const createApplicationSuccess = (data) => {
  return { type: ActionTypes.CREATE_APPLICATION_SUCCESS, payload: data };
};
const createApplicationFailure = (error) => {
  return { type: ActionTypes.CREATE_APPLICATION_FAILURE, payload: error };
};
const updateClientId = (clientId) => {
  return { type: ActionTypes.UPDATE_CLIENT_ID, payload: { clientId } };
};

export const createApplication =
  (purpose, good, amount) => async (dispatch, getState) => {
    try {
      const state = getState().checkOtpState;
      dispatch(createApplicationRequest());
      const response = await client.post("/new_app", {
        applicationId: state.app_id,
        clientId: 0,
        purpose,
        good,
        amount: +amount,
      });
      dispatch(createApplicationSuccess(response.data));
      if (state.clients && state.clients.length.length === 0) {
        const {
          payload: { clientId },
        } = response.data;
        dispatch(updateClientId(clientId));
      }
    } catch (error) {
      dispatch(createApplicationFailure(error));
    }
  };
export const selectUserForCreateApp = (user) => {
  return { type: ActionTypes.SELECT_USER_FOR_CREATE_APP, payload: user };
};

const checkTokenRequest = () => ({ type: ActionTypes.CHECK_TOKEN_REQUEST });
const checkTokenSuccess = (data) => ({
  type: ActionTypes.CHECK_TOKEN_SUCCESS,
  payload: data,
});
const checkTokenFailure = (error) => ({
  type: ActionTypes.CHECK_TOKEN_FAILURE,
  payload: error,
});

export const checkToken = (token, history) => async (dispatch) => {
  try {
    dispatch(checkTokenRequest());
    client.defaults.headers.Token = token;
    const { data } = await client.get(`/check_token`);

    if (typeof data.payload === "string" && data.payload.includes("Success")) {
      history.push("/success");
    }
    dispatch(checkTokenSuccess(data.payload));
  } catch (error) {
    if (error?.response?.data?.code === 302) {
      dispatch(setTitle(reflect.t("request_accepted")));
      dispatch(setSubTitle(reflect.t("app_already_exist")));
      history.push("/success");
      dispatch(checkTokenFailure(error));
      return;
    }
    if (error?.response?.data?.code === 401) {
      dispatch(checkTokenFailure(error));

      dispatch(throwErrorMessage("uncorrectAppId"));
    } else {
      dispatch(checkTokenFailure(error));

      dispatch(throwErrorMessage("unexpected"));
    }
    dispatch(checkTokenFailure(error));
  }
};
export const setLang = (lang) => {
  if (!lang) {
    return { type: ActionTypes.SWITCH_LANG, payload: "ru" };
  } else {
    return { type: ActionTypes.SWITCH_LANG, payload: lang };
  }
};
export const redirectFrom = (payload) => ({
  type: ActionTypes.REDIRECT,
  payload,
});
export const setLanguage = (payload) => ({
  type: ActionTypes.SWITCH_LANGб,
  payload,
});
export const sedFilesForMobi =
  (files, history) => async (dispatch, getState) => {
    try {
      const {
        query: { wallet },
      } = getState().router.location;
      const { redirect } = getState().mainState;
      dispatch(sendFilesRequest());
      const data = new FormData();
      data.append("phone", wallet);
      data.append("roistat_visit", getRoistatCookie());
      for (const item of files) {
        const name = fileNameMaker(item.file.type, item.type, item.file.size);

        if (item.file.size > 1000000) {
          const c = await compressAccurately(item.file, 500);
          data.append("files", c, name);
        } else {
          data.append("files", item.file, name);
        }
      }
      const response = await client.post("/mobi-upload", data);
      if (response.data.code !== 200) {
        throw new Error();
      }
      dispatch(sendFilesSuccess(response));
      if (redirect === "visa") {
        dispatch(push("/success/visa"));
        return;
      }
      dispatch(push("/success"));
    } catch (error) {
      console.log(error);
      dispatch(sendFilesError(error));
      dispatch(throwErrorMessage("unexpected"));
    }
  };
export const throwErrorMessage = (payload) => ({
  type: ActionTypes.THROW_ERROR_MESSAGE,
  payload,
});
export const clearError = () => ({
  type: ActionTypes.THROW_ERROR_MESSAGE,
});
